import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from 'src/environments/environment';

export const SiteOfflineGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);

  if (!environment.isSiteOffline) return true;

  const url = '/' + segments.map(s => s.path).join('/');

  if (url.startsWith('/home') || url === '/') {
    return true;
  }

  router.navigate(['/home']);
  return false;
};
